import { useRanking } from "@/hooks";
import { makePercent } from "@/utils/factorys";
import { BarChartProps } from "../../interfaces";
import { Flower } from "../flower";
import { Stalk } from "../stalk";
import { StalkFullContainer } from "./style";

export const FlowerFull: React.FC<BarChartProps> = ({ value }) => {
  const { rankingSort } = useRanking()

  return (
    <StalkFullContainer heigth={makePercent(value.indice,rankingSort[0]?.indice)}>
      <div className='containerExtern'>
        <Flower petalsData={value.petals} value={value} />
        <Stalk heigth={value.indice} father={rankingSort[0]?.indice} sigla={value.sigla} />
      </div>
    </StalkFullContainer>
  );
};
